import clsx from "clsx";
import styles from "../HowToWork.module.scss";

export const ownerConfig = {
	greeting: "Здравствуйте, Партнер!",
	title: "Короткая инструкция по вашему личному кабинету",
	toc: [
		{ id: "s-01", title: "Авторизация" },
		{ id: "s-02", title: "Инструкция в видеоформате" },
		{ id: "s-03", title: "Основной раздел личного кабинета" },
		{ id: "s-04", title: "Раздел «Торговые точки»" },
		{ id: "s-05", title: "Раздел «Продавцы»" },
		{ id: "s-06", title: "Как загружать чеки?" },
		{ id: "s-07", title: "Полные правила программы" },
		{ id: "s-08", title: "Задать вопрос" },
	],
	sections: [
		{
			id: "s-01",
			number: "01",
			title: "Авторизация",
			body: [
				{
					type: "p",
					children: (
						<>
							Авторизуйтесь, используя электронную почту, которую вы передавали
							для регистрации на портале. Это ваш логин. Пароль был отправлен на
							почту, отправитель:{" "}
							<span className={styles.borderText}>feedback@zictop.ru</span>.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/auth.png",
					mobileSrc: "/images/how_to_work/auth-mobile.png",
					alt: "Авторизация",
					width: 975,
				},
				{
					type: "alert",
					children: (
						<>
							Если пароль не пришёл или не сохранился, воспользуйтесь{" "}
							<span className={styles.borderText}>
								формой восстановления пароля
							</span>
							.
						</>
					),
				},
			],
		},

		{
			id: "s-02",
			number: "02",
			title: {
				node: (
					<>
						Воспользуйтесь{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/how-to-work-media"
						>
							инструкцией
						</a>{" "}
						в видеоформате.
						<br /> Или посмотрите описание ниже.
					</>
				),
			},
		},

		{
			id: "s-03",
			number: "03",
			title: {
				node: (
					<>
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account"
						>
							Основной раздел
						</a>{" "}
						личного кабинета
					</>
				),
			},
			body: [
				{
					type: "p",
					children:
						"Здесь вы можете отредактировать номер телефона и изменить свой пароль.",
				},
				{
					type: "image",
					src: "/images/how_to_work/editing-profile-partner.png",
					mobileSrc: "/images/how_to_work/editing-profile-partner-mobile.png",
					alt: "Редактирование профиля",
					width: 975,
				},
			],
		},

		{
			id: "s-04",
			number: "04",
			title: {
				node: (
					<>
						Раздел{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account/sale-point"
						>
							«Торговые точки»
						</a>
					</>
				),
			},
			body: [
				{
					type: "image",
					src: "/images/how_to_work/retail-outlets-partner.png",
					mobileSrc: "/images/how_to_work/retail-outlets-mobile.png",
					alt: "Торговые точки",
					width: 975,
				},
				{
					type: "p",
					children: (
						<>
							<p style={{ marginBottom: "20px" }}>
								Торговые точки — брендированные магазины или сервисы, в которых
								реализуется продукция ZIC. Зарегистрировать Торговую точку может
								Дистрибьютор или Партнер.
							</p>
							<p>
								{" "}
								Чтобы отправить заявку на регистрацию Торговой точки, нажмите
								кнопку{" "}
								<span className={styles.textBold}>
									«Зарегистрировать торговую точку»
								</span>{" "}
								и заполните данные в форме.
							</p>
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/application-registration.png",
					mobileSrc: "/images/how_to_work/application-registration-mobile.png",
					alt: "Заявка на регистрацию Торговой точки",
					width: 680,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>
							Вы сможете создать заявку только после добавления Партнера, так
							как Торговая точка прикрепляется к Партнеру.
						</>
					),
				},
				{
					type: "p",
					children: (
						<>
							После нажатия кнопки{" "}
							<span className={styles.textBold}>«Зарегистрировать»</span> придёт
							сообщение.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/succes-app-reg.png",
					mobileSrc: "/images/how_to_work/succes-app-reg-mobile.png",
					alt: "Заявка на регистрацию Торговой точки успешно отправлена",
					width: 680,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>
							Мы проверим, действительно ли Торговая точка существует и
							забрендирована, после чего активируем её на портале. Далее Партнер
							сможет добавить в неё Продавцов.
						</>
					),
				},
			],
		},

		{
			id: "s-05",
			number: "05",
			title: {
				node: (
					<>
						Раздел{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account/sellers"
						>
							«Продавцы»
						</a>
					</>
				),
			},
			body: [
				{
					type: "image",
					src: "/images/how_to_work/sellers.png",
					mobileSrc: "/images/how_to_work/sellers-mobile.png",
					alt: "Продавцы",
					width: 975,
				},
				{
					type: "p",
					children: (
						<>
							<p style={{ marginBottom: "20px" }}>
								Продавцы — непосредственные «получатели» баллов. Именно они
								загружают чеки и получают призы.
							</p>
							<p>
								В данном разделе вы можете зарегистрировать Продавца на портале.
								Для этого нажмите на кнопку{" "}
								<span className={styles.textBold}>
									«Зарегистрировать продавца»
								</span>{" "}
								и заполните форму:
							</p>
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/add-seller.png",
					mobileSrc: "/images/how_to_work/add-seller-mobile.png",
					alt: "Добавление продавца",
					width: 680,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>
							Вы сможете добавить Продавца только в подтверждённую Торговую
							точку.
						</>
					),
				},

				{
					type: "alert",
					children: (
						<>
							<p>
								На указанную в форме почту Продавец получит уведомление о
								регистрации на портале и свой пароль. Пожалуйста, заполняйте
								данные корректно. Вы не сможете их отредактировать после
								регистрации.
							</p>
							<br />
							<p>
								Если потребуется что‑то изменить, вы можете обратиться к нам,
								используя форму обратной связи{" "}
								<a className={styles.linkBorder} href="/feedback">
									https://zictop.ru/feedback
								</a>
								.
							</p>
						</>
					),
				},
			],
		},

		{
			id: "s-06",
			number: "06",
			title: "Как загружать чеки?",
			body: [
				{
					type: "p",
					children: (
						<>
							<p style={{ marginBottom: "20px" }}>
								У Партнера нет возможности загружать чеки, данный функционал
								предоставлен только Продавцу.{" "}
							</p>
							<p style={{ marginBottom: "20px" }}>
								Если вы являетесь хозяином магазина / сервиса и продавцом, то вы
								можете загружать чеки и получать баллы, но вам нужен аккаунт
								продавца.
							</p>{" "}
							<p>Как зарегистрировать продавца описано в пункте 5.</p>
						</>
					),
				},
				{
					type: "alert",
					children: (
						<p>
							<span className={styles.textBold}>Важно:</span> для аккаунта
							Продавца нужна отдельная почта и номер телефона, которые не
							повторяются с данными в аккаунте Партнера.
						</p>
					),
				},
			],
		},

		{
			id: "s-07",
			number: "07",
			title: {
				before: "Полные",
				link: { label: "правила", dynamicRules: true },
				after: "программы.",
			},
		},

		{
			id: "s-08",
			number: "08",
			title: {
				before: "Вопросы задать можно через форму обратной связи",
				link: { label: "https://zictop.ru/feedback", href: "/feedback" },
				after: ".",
			},
		},
	],
};
